import React, { useState, useEffect } from 'react';
import data from './data';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Footer1 from './footer/Footer1';
import useLocalStorage from 'use-local-storage';
import BackToTop from "../components/BackToTop"
import Marque from './Marque';
import Navbar from './navbar/Navbar';



const Awards = () => {

    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        setTimeout(() => {

            setIsLoading(false);
        },1000);        
    },[])

    const [theme, ] = useLocalStorage('theme' ? 'dark': 'light')

    //  const themeSwitch = () => {
    //     const newTheme = theme === 'light' ? 'dark' : 'light';
    //      setTheme(newTheme)
    //  }
  
  useEffect(() => {
    AOS.init();
  },[])


    const [noOfElement, setNoOfElement] = useState(8);

    const slice = data.cardData.slice(0, noOfElement);

    const loadMore = () => {
        setNoOfElement(noOfElement + 11)
    }

    const viewLess = () => {
        setNoOfElement(noOfElement - 11)
    }

    useEffect(() => {
        AOS.init();
    })

    return (
        <>
            {
                isLoading ? (<div class="load" data-theme={theme}><hr/><hr/><hr/><hr/></div>) : (
                    <div>
                        <Navbar />
                        <section id='awards' className='award_section py-12 px-4'>
                            <div className='max-w-screen-xl mx-auto p-4 flex flex-col justify-center w-50 h-full text-white '>
                                <div className="hero__info py-3 px-3">
                                    <h1 className="text-3xl text-[var(--text-secondary)] text-center pb-2 py-2 font-techFont">
                                        Awards & Certificates
                                    </h1>
                                </div>


                                <div data-aos="zoom-in-up" data-aos-duration="1500" className=' grid sm:grid-cols-3 sml:grid-cols-2 md:grid-cols-4  gap-8 text-center py-8 px-2 sm:px-1'>
                                    {slice.map((item, index) => {
                                        return (
                                            <a key={index} data-aos="flip-right"
                                            data-aos-easing="ease-out-cubic"
                                            data-aos-duration="2500" href={item.link} target='blank'>
                                                <div className='py-2 cursor-pointer justify-center rounded-lg'>
                                                    <img src={item.img} alt='Certificate img' className='exp-items h-58 w-76 md:h-68 md:w-68' />
                                                </div>
                                                <p className='text-[var(--text-secondary)]'>{item.title}</p>

                                            </a>
                                        )
                                    })
                                    }
                                </div>
                                {
                                    noOfElement === 8    ? (
                                        <button
                                            // data-aos="zoom-in-up"
                                            id='resume_btn'
                                            onClick={() => loadMore()}
                                        >
                                            View all Certificates...
                                        </button>
                                    ): (
                                        <button
                                            // data-aos="zoom-in-up"
                                            id='resume_btn'
                                            onClick={() => viewLess()}
                                        >
                                            View Less
                                        </button>

                                    )
                                }
                                    
                                    
                                



                            </div>
                        </section>
                        <Marque />
                        <Footer1 />
                        <BackToTop />
                    </div>
                )
            }
        </>
    )
}

export default Awards